import R from "ramda";
import {cloneDeep} from 'lodash'
import MergeHooks from "@/decorators/mergeHooks";
import AssociatedIot from "./associatedIot";
import { Component, Prop, Inject } from "vue-property-decorator";
import renderUtils from "@/components/RenderUtils";
import {
  tranformOptionsShape,
  getRenameKeysFunction,
} from "@/components/RenderUtils/utils/index";
import getStyles from "@/components/RenderUtils/utils/style";
import getLang from "@/components/RenderUtils/utils/lang";
import { WorkStationIotServiceProxy, WorkStationNewIotServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { GatewayServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const iotService = new WorkStationIotServiceProxy();
const gsp = new GatewayServiceProxy()
const wsnisp = new WorkStationNewIotServiceProxy()
const findGatewayList = gsp.findGatewayList.bind(gsp)

@Component({
  AssociatedIot,
})
@MergeHooks
export default class AssociatedIots extends renderUtils {
  @Prop({ default: () => [] }) readonly sourceData: Array<any>;
  @Inject() readonly refresh!: any;
  @Prop() workstation!: any;
  @Prop() workstationId!: any;
  // @Prop() newType: boolean; // 新版本/老版本
  showModal = false;
  newType = false;
  filter = ''
  list = []
  newIot:any = {}

  get lang() {
    return getLang(this);
  }

  get schema() {
    return {
      iotId: {
        multiKeys: ["iotName", "iotCode"],
        label: this.lang.related_to_iot,
        placeholder: this.$t('please_select') +  this.lang.related_to_iot,
        type: "select",
        props: {
          showSearch: this.newType,
          filterOption: false
        },
        options: this.list,
        rules: [
          {
            required: true,
            message: this.lang.related_to_iot_required,
          },
        ],
        on: {
          change: (val) => {
            this.newIot = this.list.find(item => item.value === val)
            console.log(1111, val, this.list, this.newIot)
          },
          search: (val)=> {
            this.filter = val
            this.getOptions()
          },
          focus: () => {
            this.getOptions()
          }
        }
      },
    };
  }

  // 获取下拉列表数据
  async getOptions() {
    this.list = []
    if (this.newType) { // 关联新版本设备
      const arr = await R.pipe(
        wsnisp.getIots.bind(wsnisp),
        R.andThen(tranformOptionsShape('iotCode', 'iotId'))
      )()
      this.list = arr.filter(res => res.value.indexOf(this.filter) != -1 || res.label.indexOf(this.filter) != -1)
    } else {
      this.list = await R.pipe(
        iotService.getIots.bind(iotService),
        R.andThen(tranformOptionsShape('iotCode', 'iotId'))
      )()
    }
  }

  renderIots() {
    return R.map(this.renderIot, this.sourceData);
  }
  renderIot(data) {
    return (
      <AssociatedIot sourceData={data} workstationId={this.workstationId} />
    );
  }

  render() {
    return (
      <div style={getStyles("wrapper")}>
        {this.renderIots()}
        {this.renderModal()}
      </div>
    );
  }

  renderModal() {
    const props = {
      show: this.showModal,
      schema: this.schema,
      ok: this.submitIot,
      cancel: this.setState("showModal"),
      ref: "relate",
      footer: "default",
      title: this.newType ?  this.lang.associate_new : this.lang.associate_old
    };
    return this.renderDialogWithForm(props);
  }

  addIot(type?) {
    this.setState("showModal")(true);
    this.setState("newType")(type);
  }

  /*关联iot网关*/
  submitIot(value) {
    const changeKeysName = getRenameKeysFunction({
      id: "workStationId",
      code: "workStationCode",
    });

    const mergeForm = R.pipe(
      R.pick(["id", "code"]),
      changeKeysName
    )(this.workstation);

    const effectCb = () => {
      this.$message.success(this.lang.create_success);
      this.setState("showModal")(false);
      this.refresh.associatedIots();
    };

    let temp = {
      iotVersion: 0,
      ...value
    }

    if(this.newType) {
      temp.iotVersion = 1
      console.log('value:', value, this.workstation, this.newIot)
      let params = {
        ...temp,
        iotCode: this.newIot.label,
        // iotId: value.iotId,
        iotName: this.newIot.label,
        // workStationCode: this.workstation.code,
        // workStationId: this.workstationId
      }
      R.pipe(
        R.merge(mergeForm),
        wsnisp.workStationIotRelation.bind(wsnisp),
        R.andThen(effectCb)
      )(params);
    } else {
      R.pipe(
        R.merge(mergeForm),
        iotService.createWorkStationIot.bind(iotService),
        R.andThen(effectCb)
      )(temp);
    }
  }
}
